"use client";
import { jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { SimpleGrid } from "@mantine/core";
import { forwardRef } from "react";
import GridItem, { G as GridStyles } from "./GridItem.js";
const _Grid = forwardRef((props, ref) => {
  const { columns = 1, rows = 1, container, item, style, mod, className, ...rest } = props;
  if (item) {
    const { ...gridItemProps } = rest;
    delete gridItemProps.container;
    return /* @__PURE__ */ jsx(
      GridItem,
      {
        ref,
        ...gridItemProps,
        item: true,
        columns,
        rows,
        className,
        style,
        mod
      }
    );
  }
  const {
    xs,
    sm,
    md,
    lg,
    xl,
    spacing = "sm",
    children,
    columnSpacing,
    rowSpacing,
    flow = "column",
    fill,
    ...containerRest
  } = rest;
  const resolveValue = (value) => {
    if (typeof value === "number") {
      return `repeat(${value}, minmax(0, 1fr))`;
    }
    return value;
  };
  const styleVariables = {
    "--passed-columns": resolveValue(columns),
    "--passed-rows": resolveValue(rows || "auto"),
    "--passed-cols-xs": resolveValue(xs || columns),
    "--passed-cols-sm": resolveValue(sm || xs || columns),
    "--passed-cols-md": resolveValue(md || sm || xs || columns),
    "--passed-cols-lg": resolveValue(lg || md || sm || xs || columns),
    "--passed-cols-xl": resolveValue(xl || lg || md || sm || xs || columns)
  };
  return /* @__PURE__ */ jsx(
    SimpleGrid,
    {
      ...containerRest,
      ref,
      spacing,
      className: `${GridStyles.container} ${className}`,
      style: { ...styleVariables, ...style },
      mod: { columnSpacing, rowSpacing, flow, container, ...mod, fill },
      children
    }
  );
});
_Grid.displayName = "Grid";
const Grid = sharedHandler(_Grid);
Grid.displayName = _Grid.displayName;
export {
  Grid as default
};
